export default __webpack_public_path__ + "static/media/barcode.1bd48f1b.svg";